import React, {FC} from 'react';
import {Icon} from './Icon';
import DaumPostcode, {Address} from "react-daum-postcode";

interface AddressPopUpProps {
    open: boolean;
    onClose: () => void;
    onSelected: (data: Address) => void;
}

export const PostPopUp: FC<AddressPopUpProps> = ({onClose, open, onSelected}) => {
    if (!open) return <></>;
    return (
        <>
            <div className="z-50 fixed inset-0 bg-littleblack flex items-start md:items-center justify-center p-2">
                <div className="xl:w-5/12 md:w-3/5 w-full flex flex-col  bg-white p-6 space-y-4 overflow-y-auto">
                    <div className="flex flex-row justify-between ">
                        <p className="text-15 font-medium">주소 검색</p>
                        <button
                            onClick={onClose}
                            className="flex wh-5 flex-row space-x-2 items-center"
                        >
                            <Icon.X/>
                        </button>
                    </div>
                    <DaumPostcode onComplete={data => onSelected(data)}/>
                </div>
            </div>
        </>
    );
};
